import Vue from 'vue';
import Vuex from 'vuex';
import dashboard from '@/stores/dashboard.ts';
import modals from '@/stores/modals.ts';
import partner from '@/stores/partner.ts';
import toast from '@/stores/toast.ts';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store: any = new Vuex.Store({
  modules: {
    dashboard,
    modals,
    partner,
    toast,
  },
  plugins: [
    createPersistedState({
      paths: ['partner.lang', 'partner.token', 'partner.id', 'partner.externalId', 'partner.hasVariablePricing'],
      storage: sessionStorage,
    }),
    createPersistedState({
      paths: ['modals.mobileMessage'],
      storage: localStorage,
    }),
  ],
});

export default store;
